import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UserEntitlements } from '@ddv/entitlements';
import { IconComponent } from '@hs/ui-core-presentation';

import { DashboardWithoutWidgets } from '../../../models/dashboard-without-widgets';
import { Sharing } from '../../../models/sharing';
import { ViewTile } from '../../../models/view-tile';
import { canEnterEditMode } from '../../../utils/can-enter-edit-mode';
import { PeerCarouselComponent } from '../peer-carousel/peer-carousel.component';

@Component({
    selector: 'ddv-dashboard-name-view',
    templateUrl: './header-name-view.component.html',
    styleUrls: ['./header-name-view.component.scss'],
    imports: [
        IconComponent,
        PeerCarouselComponent,
    ],
})
export class HeaderNameViewComponent implements OnChanges {
    @Input() dashboard: DashboardWithoutWidgets | undefined;
    @Input() group: ViewTile | undefined;
    @Input() entitlements: UserEntitlements | undefined;
    @Input() sharing: Sharing | undefined;

    @Output() switchToEditMode = new EventEmitter<void>();
    @Output() dashboardSwitch = new EventEmitter<string>();

    protected shouldHideEditIcon = true;
    private readonly canEnterEditMode = canEnterEditMode;

    ngOnChanges(): void {
        this.showHideEditIcon();
    }

    private showHideEditIcon(): void {
        if (!this.dashboard?.id || !this.entitlements || this.dashboard?.privilege === 'VIEW') {
            this.shouldHideEditIcon = true;
        } else {
            this.shouldHideEditIcon = !this.canEnterEditMode(
                this.dashboard.createdBy,
                this.dashboard.isGlobal,
                this.sharing,
                this.entitlements);
        }
    }
}
